export default {
  "weather.sunny": "晴れ",
  "weather.cloudy": "曇り",
  "weather.raining": "雨",
  "weather.thunderstorm": "雷雨",
  "weather.storm": "暴風雨",
  "weather.snow": "雪",
  "weather.heavySnow": "大雪",
};